export default __webpack_public_path__ + "static/media/icon-glass.e3a3b8ab.svg";